import { getAddCarSteps } from '../common/addcars';

// List of adding car steps for /policy flow (cars & drivers on same page).
export const AddCarStepsBeforeOnboardingSteps = getAddCarSteps({
  flowFilter: (appData) => {
    if (appData.addingNewCar) {
      return true;
    }

    // If insurance is selected, cars will be asked in the onboarding section.
    if (appData.selectedService?.insurance) {
      return false;
    }

    return !!(appData.selectedService?.garage || appData.selectedService?.dwep || appData.selectedService?.refi);
  },
});
